module.exports = __webpack_public_path__ + "components/rewards/app/static/logo-d3a5de88d7a456124d63d97a1dcc031e.jpg";